export default "__VITE_ASSET__MAlXfQBL__"